
"use client";

import Autoplay from "embla-carousel-autoplay";
import Image from "next/image";
import { useEffect, useState } from "react";

import { services_care } from "@/data/services";

import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "./ui/carousel";

const CtaServicesCarousel = () => {

  const [api, setApi] = useState<CarouselApi>()
  const [current, setCurrent] = useState(0)
  const [count, setCount] = useState(0)
  
  useEffect(() => {
    if (!api) {
      return
    }
  
    setCount(api.scrollSnapList().length)
    setCurrent(api.selectedScrollSnap() + 1)
  
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1)
    })
  }, [api])
  
  return (
     <div className="mb-8 block md:hidden">

            <Carousel
              setApi={setApi}
              className="w-full" 
              opts={{ align: "start", loop: true,  }}
              plugins={[
                Autoplay({
                  delay: 5000,
                }),
              ]}
            >
            <CarouselContent className="-ml-4">
              {services_care.map((service) => (
                <CarouselItem className="flex flex-col gap-3 items-center justify-center md:justify-start" key={service.id}>
                  <Image src={service.image} width={80} height={80} alt="paw" />
                  <p className="text-white text-lg font-bold text-balance">
                    {service.label}
                  </p>
                </CarouselItem>
              ))}

              </CarouselContent>
            </Carousel>

            <div className="flex justify-center mt-8 mb-10 gap-2 md:gap-3">
                {Array.from({ length: count }).map((_, index) => (
                  <button
                    key={index}
                    aria-label="mark slider"
                    onClick={() => api?.scrollTo(index)}
                    className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-200 ${
                      index === current - 1 ? "bg-secondary ring-1 ring-offset-2 ring-secondary" : "bg-slate-300 "
                    }`}
                  />
                ))}
              </div>

          </div>
  );
}
 
export default CtaServicesCarousel;